import React from "react";
import { useNavUtils } from "../utils/navUtils";
import UserLogoutBar from "./UserLogoutBar";
import "../styles/components/SessionEnded.css";

const SessionEnded: React.FC = () => {
  const { goNav } = useNavUtils();

  const handleRelaunch = () => {
    goNav("/investor-linkedin-completion");
  };

  return (
    <div className="session-ended-container">
      <UserLogoutBar />
      <div className="content">
        <div className="session-ended-text">Thanks for checking out the demo.</div>
        <div className="session-ended-buttons">
          <button className="restart-button" onClick={handleRelaunch}>
            Restart
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionEnded;
